import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import dateFormat from 'dateformat';
import { connect } from 'react-redux';
import s from '../../assets/styles/style.sass';
import s2 from '../order/Order.sass';
import { setIsShowBonusPriceDialog } from '../../actions/dialog';
import OrderSummarySumbitButton from './OrderSummarySumbitButton';
import OrderSummary01Route from './OrderSummary01Route/OrderSummary01Route';
import OrderSummary02PickupTime from './OrderSummary02PickupTime/OrderSummary02PickupTime';
import OrderSummary03VehicleIN from './OrderSummary03Vehicle/OrderSummary03VehicleIN';
import OrderSummary06Remark from './OrderSummary06Remark/OrderSummary06Remark';
import OrderSummary07SenderInfo from './OrderSummary07SenderInfo/OrderSummary07SenderInfo';
import OrderSummary11Fee from './OrderSummary11Fee/OrderSummary11Fee';
import OrderSummary13Payment from './OrderSummary13Payment/OrderSummary13Payment';

class inOrderSummary extends React.Component {
  static propTypes = {
    onClickConfirm: PropTypes.func.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
  };

  render() {
    return (
      <div className={`${s2.orderSummary}`} style={{ display: 'block' }}>
        <section className={s2.orderSummary}>
          <div>
            <h2>{this.props.modelDataText.order_summary_title}</h2>
          </div>
        </section>

        {/* Route */}
        <OrderSummary01Route modelDataText={this.props.modelDataText} />

        {/* Pickup Time */}
        <OrderSummary02PickupTime
          modelDataText={this.props.modelDataText}
          value={dateFormat(
            this.props.orderDetailInfo.pickup_time,
            'dd mmmm, yyyy ,HH:MM',
          )}
        />

        {/* vehicle */}
        <OrderSummary03VehicleIN
          modelDataText={this.props.modelDataText}
          modelData={this.props.modelData}
        />

        {/* Remark */}
        <OrderSummary06Remark
          modelDataText={this.props.modelDataText}
          value={[this.props.orderDetailInfo.remark]}
        />

        {/* sender info */}
        <OrderSummary07SenderInfo modelDataText={this.props.modelDataText} />

        {/* Fee */}
        <OrderSummary11Fee modelDataText={this.props.modelDataText} />

        {/* payment method */}
        <OrderSummary13Payment modelDataText={this.props.modelDataText} />

        <br />
        <OrderSummarySumbitButton
          modelDataText={this.props.modelDataText}
          onClickConfirm={this.props.onClickConfirm}
        />
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
const mapDispatch = {
  setIsShowBonusPriceDialog,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(inOrderSummary),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/inOrderSummary.js